import apiHandler from "./apiHandler";

const apiSimBrief = {
  getApiKey: (api_req) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get("/flight/simbriefkey/" + api_req)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchOFP: (id) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(
          `https://www.simbrief.com/api/xml.fetcher.php?json=1&static_id=newsky_${id}`,
          { withCredentials: false },
        )
        .then((response) => {
          const ofp = response.data;

          // console.log(ofp);

          ofp.general = {
            route: ofp.general.route_ifps,
            dx_rmk: ofp.general.dx_rmk,
            sys_rmk: ofp.general.sys_rmk,
          };

          ofp.fuel = {
            taxi: ofp.fuel.taxi,
            enroute: ofp.fuel.enroute_burn,
            contingency: ofp.fuel.contingency,
            alternate: ofp.fuel.alternate_burn,
            reserve: ofp.fuel.reserve,
            avg_fuel_flow: ofp.fuel.avg_fuel_flow,
          };

          const limitedNavlogFix = [];

          limitedNavlogFix.push({
            ident: ofp.origin.icao_code,
            type: "apt",
            pos_lat: ofp.origin.pos_lat,
            pos_long: ofp.origin.pos_long,
            stage: "CLB",
          });

          if (ofp.navlog.fix !== undefined) {
            for (const one of ofp.navlog.fix) {
              if (one.is_sid_star == 0) {
                limitedNavlogFix.push({
                  ident: one.ident,
                  type: one.type,
                  pos_lat: one.pos_lat,
                  pos_long: one.pos_long,
                  stage: one.stage,
                });
              }
            }
          }

          limitedNavlogFix.push({
            ident: ofp.destination.icao_code,
            type: "apt",
            pos_lat: ofp.destination.pos_lat,
            pos_long: ofp.destination.pos_long,
            stage: "DES",
          });

          ofp.navlog = {
            fix: limitedNavlogFix,
          };

          ofp.origin = {
            icao: ofp.origin.icao_code,
            trans_level: ofp.origin.trans_level,
            trans_alt: ofp.origin.trans_alt,
          };

          ofp.destination = {
            icao: ofp.destination.icao_code,
            trans_level: ofp.destination.trans_level,
            trans_alt: ofp.destination.trans_alt,
          };

          ofp.alternate = {
            icao: ofp.alternate.icao_code,
            trans_level: ofp.alternate.trans_level,
            trans_alt: ofp.alternate.trans_alt,
          };

          ofp.weights = {
            oew: ofp.weights.oew,
            pax: ofp.weights.pax_count_actual,
            pax_weight: ofp.weights.pax_weight,
            bags: ofp.weights.bag_count_actual,
            bag_weight: ofp.weights.bag_weight,
            freight_added: ofp.weights.freight_added,
            cargo: ofp.weights.cargo,
            payload: ofp.weights.payload,
            est_zfw: ofp.weights.est_zfw,
            est_tow: ofp.weights.est_tow,
            est_ldw: ofp.weights.est_ldw,
          };

          delete ofp.fetch;
          delete ofp.enroute_altn;
          delete ofp.takeoff_altn;
          delete ofp.database_updates;
          // delete ofp.aircraft;
          delete ofp.atc;
          delete ofp.crew;
          delete ofp.etops;
          delete ofp.files;
          delete ofp.images;
          delete ofp.impacts;
          delete ofp.links;
          delete ofp.notams;
          delete ofp.sigmets;
          delete ofp.times;
          delete ofp.tracks;
          delete ofp.fms_downloads;
          delete ofp.weather;
          // delete ofp.prefile;
          delete ofp.ivao_prefile;
          delete ofp.pilotedge_prefile;
          delete ofp.vatsim_prefile;
          delete ofp.poscon_prefile;
          delete ofp.map_data;
          delete ofp.api_params;
          resolve(ofp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default apiSimBrief;
